export default "__VITE_ASSET__CywKfhFw__"